 import React from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const Campuscare = () => {
  return (
     <>
         <div className="campuslogo">
              <Link to="https://www.pcscampuscare.org/" target="_blank">
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/Campulogo.png" className="img-fluid float-end campus" alt="PCS Delhi"/></LazyLoad></Link>
         </div>  
      </>
        
  )
}

export default Campuscare
 